export default [
  {
    title: 'Dashboards',
    icon: 'GridIcon',
    resource: 'ACL',
    action: 'read',
    children: [
      {
        title: 'Analytics Chat',
        route: 'DashboardChat',
        icon: 'GridIcon',
        resource: 'CHATBOOSTER',
        action: 'chatbooster',
      },
      {
        title: 'Analytics VSL',
        route: 'DashboardVsl',
        icon: 'GridIcon',
        resource: 'VSLBOOSTER',
        action: 'vslbooster',
      },
    ],
  },
  {
    title: 'Meus Videos',
    route: 'Meus-Videos',
    icon: 'VideoIcon',
    // acl: {
    resource: 'VSLBOOSTER',
    action: 'vslbooster',
    // },
  },
  {
    title: 'Chat',
    icon: 'MessageSquareIcon',
    route: 'chats',
    resource: 'CHATBOOSTER',
    action: 'chatbooster',
    // children: [
    //   {
    //     title: 'Fluxos',
    //     route: 'chats',
    //   },
    //   {
    //     title: 'Leads',
    //     route: 'leads',
    //   },
    //   {
    //     title: 'Analytics',
    //     route: 'dashbordChats',
    //   },
    //   {
    //     title: 'Editar',
    //     route: { name: 'apps-users-edit', params: { id: 21 } },
    //   },
    // ],
  },

  // {
  //   title: 'Testes A/B ',
  //   route: 'teste-ab',
  //   icon: 'ThermometerIcon',
  // },

  // {
  //   title: 'Segurança',
  //   route: 'Seguranca',
  //   icon: 'ShieldIcon',
  // },
  {
    title: 'Usuário',
    icon: 'UserIcon',
    resource: 'all',
    action: 'manage',
    children: [
      {
        title: 'Lista',
        route: 'apps-usuarios-lista',
      },
      // {
      //   title: 'View',
      //   route: { name: 'apps-users-view', params: { id: 21 } },
      // },
      // {
      //   title: 'Editar',
      //   route: { name: 'apps-users-edit', params: { id: 21 } },
      // },
    ],
  },
  {
    title: 'Meus Cursos',
    icon: 'BookOpenIcon',
    route: 'courses',
    resource: 'CURSOS',
    action: 'read',
  },
  {
    title: 'Webinário',
    route: 'webinar-simulator',
    icon: 'VideoIcon',
    resource: 'VSLBOOSTER',
    action: 'vslbooster',
  },
  {
    title: 'Modulos Treinamentos',
    icon: 'BookOpenIcon',
    resource: 'CURSOS',
    action: 'read',
    children: [
      {
        title: 'Chat Booster',
        route: 'treinamentos-chatbooster',
        icon: 'BarChart2Icon',
        resource: 'CHATBOOSTER',
        action: 'read',
      },
      {
        title: 'VSL Booster',
        route: 'treinamentos-vslbooster',
        icon: 'BarChart2Icon',
        resource: 'VSLBOOSTER',
        action: 'read',
      },
    ],
  },
  {
    title: 'Administração',
    icon: 'SettingsIcon',
    resource: 'all',
    action: 'manage',
    children: [
      {
        title: 'Tour Virtual',
        route: 'tour-virtual',
        icon: 'HelpCircleIcon',
        resource: 'TOUR_VIRTUAL',
        action: 'manage',
      },
      {
        title: 'TreinamentosAdmin',
        route: 'adminTreinamentos',
        icon: 'BookOpenIcon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Pagamentos',
        route: 'pagamentos',
        icon: 'BookOpenIcon',
        resource: 'all',
        action: 'manage',
      },
    ],
  },
  {
    title: 'Universidade Corp',
    icon: 'BookOpenIcon',
    resource: 'VSLBOOSTER',
    action: 'vslbooster',
    children: [
      {
        title: 'Cursos',
        route: 'cliTreinamentos',
        icon: 'BookOpenIcon',
        resource: 'CURSOS',
        action: 'read',
      },
      {
        title: 'Alunos',
        route: 'cadAluno',
        icon: 'BookOpenIcon',
        resource: 'CURSOS',
        action: 'read',
      },
    ],
  },
]
